@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@chevron-width: 8px;
@chevron-line-width: 2px;
@chevron-total-width: ~'calc(@{chevron-width} + @{chevron-line-width})';
@chevron-h-padding: 10px;

@wizard-height: 32px;
@wizard-footer-height: 50px;
@wizard-half-height: ~'calc(0.5 * @{wizard-height})';

@wizard-background-color: @wizard--background-color;
@wizard-step-background-color: @wizard--step-content--background-color;

@standard-spacing: 24px;
@alternate-spacing: 10px;

.wizard-wrapper {
  height: 100%;
  width: 100%;
}

.wizard-header {
  position: absolute;
  top: 0;
  z-index: 100;
  width: 100%;
  display: flex;
  border-bottom: 1px solid @wizard--header--border-color;
  background-color: @wizard-background-color;

  .wizard-step-header {
    height: @wizard-height;
    background-color: @wizard-step-background-color;
    color: @wizard--step-header--text-color;
    line-height: @wizard-height;
    font-size: 14px;

    &:first-of-type {
      padding-left: @standard-spacing;
    }

    &.selected {
      color: @wizard--step-header--selected--text-color;
      font-weight: 500;
    }
  }

  .chevron {
    width: @chevron-total-width;
    margin: 0 ~'calc(@{chevron-total-width} + @{chevron-h-padding})' 0 0;
    padding-right: @chevron-h-padding;
    background-color: @wizard-step-background-color;
    color: @wizard--header--fill-color;
    height: @wizard-height;
    line-height: @wizard-height;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      background-color: @wizard-step-background-color;
      height: @wizard-height;
      width: ~'calc(2 * @{chevron-total-width})';
      right: ~'calc(-2 * @{chevron-total-width})';
    }

    &.selected {
      &:before,
      &:after {
        content: '';
        position: absolute;
        background-color: transparent;
        right: ~'calc(-1 * @{chevron-total-width})';
      }

      &:before {
        border-top: @wizard-half-height solid @wizard-header-chevron-before--border-color;
        border-bottom: @wizard-half-height solid @wizard-header-chevron-before--border-color;
        border-right: @chevron-line-width solid @wizard-header-chevron-before--border-color;
        border-left: @chevron-width solid @wizard-header-chevron-before-left--border-color;
        width: @chevron-total-width;
      }

      &:after {
        border-top: @wizard-half-height solid @wizard-header-chevron-after--border-color;
        border-bottom: @wizard-half-height solid @wizard-header-chevron-after--border-color;
        border-left: @chevron-width solid transparent;
        height: @wizard-height;
        width: @chevron-width;
      }

      & ~ .wizard-step-header {
        background-color: @wizard-background-color;
        color: @wizard--step-header--selected--sibling--text-color;

        &:before {
          background-color: @wizard-background-color;
        }
      }

      & ~ .chevron {
        background-color: @wizard-background-color;
        &:before {
          background-color: @wizard-background-color;
        }
      }
    }
  }
}

.wizard-body {
  width: 100%;
  position: absolute;
  top: @wizard-height;
  height: ~'calc(100% - @{wizard-height} - @{wizard-footer-height})';
  overflow-y: auto;
  padding: @alternate-spacing @standard-spacing;
}

.footer-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 100;
}

.wizard-footer {
  display: flex;
  width: 100%;
  height: @wizard-footer-height;
  justify-content: space-between;
  background-color: @wizard-background-color;

  & > {
    align-items: center;
  }

  .wizard-footer-left {
    margin-left: @standard-spacing;
  }

  .wizard-footer-right {
    padding: 8px 0;
    & > * {
      margin-right: @alternate-spacing;
    }
  }
}
